import { Language } from 'components/Layout/Language/useLanguage';
import { generatePath } from 'react-router-dom';

export const RoutePaths = {
    Home: {
        route: (lng: Language) => `/${lng}/`,
        url: (lng: Language) => RoutePaths.TermsOfUse.Contact.route(lng),
        title: 'Home',
    },
    TermsOfUse: {
        Client: {
            route: (lng: Language) => `/${lng}/terms-of-use/:requestId`,
            url: (lng: Language, requestId: string) => generatePath(RoutePaths.TermsOfUse.Client.route(lng), { requestId: `${cleanUrlParameter(requestId)}` }),
        },
        Contact: {
            route: (lng: Language) => `/${lng}/terms-of-use`,
            url: (lng: Language) => RoutePaths.TermsOfUse.Contact.route(lng),
        },
    },
} as const;

export type RouteParams = {
    requestId?: string
}

const cleanUrlParameter = (parameter?: string) => {
    if (!parameter) {
        return parameter;
    }
    return encodeURIComponent(parameter);
};
